// --- INJECTED ---
import { getI18n } from '@/core/i18n';
const i18n = getI18n();
// --- /INJECTED ---

const breadCrumb = [
    {
        label: i18n.t('common.inventory.title'),
        route: { name: 'inventory$inventory' },
    },
];

export default [
    {
        path: '/inventory',
        name: 'inventory$inventory',
        component: () => import('@/apps/inventory/views/List'),
        meta: {
            breadCrumb: [breadCrumb[0]],
            title: i18n.t('common.inventory.title'),
        },
    }
];
